import { SignableOfferForm } from './SendSignableOfferModal';
import { formatSalary } from '../../../utils/formatSalary';

export interface Variable {
  name: string;
  variable: string;
  type: 'Numeric' | 'Signature' | 'Date' | 'Text' | 'Salary';
  label: string;
  form: boolean;
  suffix?: string;
}

export const SIGNABLE_OFFER_VARIABLES: Variable[] = [
  {
    name: 'bonus',
    variable: 'Bonus',
    type: 'Salary',
    label: 'Bonus',
    form: true,
  },
  {
    name: 'candidateSignature',
    variable: 'Candidate E-Signature',
    type: 'Signature',
    label: 'Candidate E-Signature',
    form: false,
  },
  {
    name: 'candidateDate',
    variable: 'Candidate E-Signature Date',
    type: 'Date',
    label: 'Candidate E-Signature Date',
    form: false,
  },
  {
    name: 'candidateInitials',
    variable: 'Candidate E-Signature Initials',
    type: 'Signature',
    label: 'Candidate E-Signature Initials',
    form: false,
  },
  {
    name: 'candidateName',
    variable: "Candidate's Name",
    type: 'Text',
    label: "Candidate's Name",
    form: true,
  },
  {
    name: 'companySignature',
    variable: 'Company E-Signature',
    type: 'Signature',
    label: 'Company Signature',
    form: false,
  },
  {
    name: 'companyDate',
    variable: 'Company E-Signature Date',
    type: 'Date',
    label: 'Company Signature Date',
    form: false,
  },
  {
    name: 'companyInitials',
    variable: 'Company E-Signature Initials',
    type: 'Signature',
    label: 'Company Signature Initials',
    form: false,
  },
  {
    name: 'companyName',
    variable: 'Company Name',
    type: 'Text',
    label: 'Company Name',
    form: true,
  },
  {
    name: 'directManager',
    variable: 'Direct Manager',
    type: 'Text',
    label: 'Direct Manager',
    form: true,
  },
  {
    name: 'equity',
    variable: 'Equity',
    type: 'Numeric',
    label: 'Equity',
    form: true,
  },
  {
    name: 'jobTitle',
    variable: 'Job Title',
    type: 'Text',
    label: 'Job Title',
    form: true,
  },
  {
    name: 'offerExpirationDate',
    variable: 'Offer Expiration Date',
    type: 'Date',
    label: 'Offer Expiration Date',
    form: true,
  },
  {
    name: 'paidTimeOff',
    variable: 'Paid Time Off',
    type: 'Numeric',
    label: 'Paid Time Off',
    form: true,
    suffix: ' days',
  },
  {
    name: 'salary',
    variable: 'Salary',
    type: 'Salary',
    label: 'Salary',
    form: true,
  },
  {
    name: 'senderName',
    variable: 'Sender Name',
    type: 'Text',
    label: 'Sender Name',
    form: true,
  },
  {
    name: 'sickDays',
    variable: 'Sick Days',
    type: 'Numeric',
    label: 'Sick Days',
    form: true,
    suffix: ' days',
  },
  {
    name: 'startingDate',
    variable: 'Starting Date',
    type: 'Date',
    label: 'Starting Date',
    form: true,
  },
  {
    name: 'todayDate',
    variable: "Today's Date",
    type: 'Date',
    label: "Today's Date",
    form: true,
  },
  {
    name: 'workingHours',
    variable: 'Working Hours',
    type: 'Numeric',
    label: 'Working Hours (weekly)',
    form: true,
    suffix: 'h',
  },
];

function handleInput(
  v: Variable,
  form: Record<string, any>,
  fieldName: string,
) {
  if (v.type !== 'Salary') return form[fieldName];

  const currencyFieldName = `${fieldName}Currency`;

  return formatSalary(form[fieldName], form[currencyFieldName]);
}

export function variablesToMap(
  form: SignableOfferForm,
  selectedVariableKeys?: string[],
): Record<string, any> {
  const newMap = form.customVariables;

  SIGNABLE_OFFER_VARIABLES.filter((v) => v.form === true).forEach((v) => {
    const fieldName = v.name as keyof SignableOfferForm;

    newMap.set(v.name, handleInput(v, form, fieldName));
  });

  const result = Object.fromEntries(newMap);

  if (selectedVariableKeys?.length) {
    return Object.fromEntries(
      Object.entries(result).filter(([key]) =>
        selectedVariableKeys.includes(key),
      ),
    );
  } else {
    return result;
  }
}
